'use client'
import { Spinner } from "flowbite-react";
import React from "react";

function Loader() {
  return (
    <div className="fixed left-0 z-[100000] right-0 top-0 bg-slate-300 bg-opacity-80 bottom-0 flex justify-center items-center ">
      <Spinner
        size="xl"
        color="purple"
      />
    </div>
  );
}

export default Loader;
